<template>
    <div style="width: 400px">
        <Row>
            <Col span="2">{{$t('l.floor')}}</Col>
            <Col :span="isThroughDoor?'7':'15'" class="text-center">{{$t('l.floor_name')}}</Col>
            <Col :span="isThroughDoor?'4':'7'" class="text-center">{{$t('l.unstop')}}</Col>
            <template v-if="isThroughDoor">
                <Col span="7" class="text-center">{{$t('l.floor_name')}}</Col>
                <Col span="4" class="text-center">{{$t('l.unstop')}}</Col>
            </template>
        </Row>
        <div style="max-height: 300px; overflow-y: auto">
            <Row v-for="i in (negative+positive)" :key="i" style="margin-top: 3px;display: flex;align-items: center">
                <Col span="2">{{floorIndexs[total-i]}}</Col>
                <Col span="22">
                    <Row>
                        <Col :span="isThroughDoor?'8':'16'"><Input v-model="floors.display[total-i]" class="text-center"/></Col>
                        <Col :span="isThroughDoor?'4':'8'" class="text-center"><Checkbox :value="floors.unstop.includes(total-i)" @on-change="onUnstopChange($event, total-i)"></Checkbox></Col>
                        <template v-if="isThroughDoor">
                            <Col span="8"><Input v-model="floors.display[total + total - i]" class="text-center"/></Col>
                            <Col span="4" class="text-center"><Checkbox :value="floors.unstop.includes(total + total - i)" @on-change="onUnstopChange($event, total + total - i)"></Checkbox></Col>
                        </template>
                    </Row>
                </Col>

            </Row>
        </div>
        <Row class="margin-top-10" type="flex" justify="end">
            <Col><Button @click="$emit('on-close')">{{$t('l.close')}}</Button></Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: "floor-editor",
        props: {
            positive: Number,
            negative: Number,
            floors: {
                type: Object,
                default: {
                    display: [],
                    unstop: []
                }
            },
            isThroughDoor: {
                type: Number,
                default: 0
            }
        },
        computed: {
            floorIndexs() {
                let indexs = [];
                // for (let i = 1; i <= this.positive; i++) { // 遍历正楼层
                //     indexs.push(i.toString())
                // }
                // for (let i = 1; i <= this.negative; i++) { // 遍历负楼层
                //     indexs.unshift((-i).toString())
                // }
                // this.total.map((elem,index)=>{
                //     return index+1+"";
                // })
                for (let i=1;i<=this.positive + this.negative;i++){
                    indexs.push(i+"");
                }
                return indexs;
            },
            total () {
                return this.positive + this.negative;
            }
        },
        methods: {
            onUnstopChange (status, index) {

                if (status) {
                    this.floors.unstop.push(index);
                } else {
                    this.floors.unstop.splice(this.floors.unstop.indexOf(index), 1);
                }
            }
        }
    }
</script>

<style scoped>
.text-center {
    text-align: center;
}
</style>